import React, {useCallback, useMemo} from 'react';
import {PasswordContainer} from '../../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../../components/Settings/SettingsPageContainer';
import {onClickHandler} from '../../../../../utils/onclick';
import './index.scss';
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {GatewayCommand} from '../../../../../types/control';
import {useQuestion} from '../../../../../hooks/question';
import {useMessage} from '../../../../../hooks/message';
import {useRPC} from '../../../../../hooks/rpc';
import {useLocalization} from "../../../../../hooks/localization";

export function GatewayControlScreen() {
    const {t} = useLocalization();
    const {id} = useParams();
    const [rpc] = useRPC();
    const question = useQuestion();
    const {success} = useMessage();

    const gatewayList = useSelector(state => state.control.gatewayList);
    const selectedGateway = useMemo(() => gatewayList.find((g) => g.id === id), [gatewayList, id]);

    const onShutdownClick = useCallback(() => {
        question(t('the_gateway_will_be_closed__continue',{name:selectedGateway.name}), () => {
            success(t('closing'));
            rpc.manageGateway(selectedGateway.id, GatewayCommand.Shutdown);
        });
    }, [
        t,
        question,
        rpc,
        selectedGateway.id,
        selectedGateway.name,
        success,
    ]);

    const onRestartClick = useCallback(() => {
        question(t('the_gateway_will_be_rebooted__continue',{name: selectedGateway.name}), () => {
            success(t('rebooting'));
            rpc.manageGateway(selectedGateway.id, GatewayCommand.Reboot);
        });
    }, [
        t,
        rpc,
        question,
        selectedGateway,
        success,
    ]);

    const onSupervisorRestartClick = useCallback(() => {
        question(t('the_gateway_supervisor_will_be_rebooted__continue',{name:selectedGateway.name}), () => {
            success(t('supervisor_rebooting'));
            rpc.manageGateway(selectedGateway.id, GatewayCommand.RestartSupervisor);
        });
    }, [
        t,
        question,
        rpc,
        selectedGateway.id,
        selectedGateway.name,
        success,
    ]);

    const onWorkerRestartClick = useCallback(() => {
        question(t('the_gateway_worker_will_be_rebooted__continue',{name:selectedGateway.name}), () => {
            success(t('worker_rebooting'));
            rpc.manageGateway(selectedGateway.id, GatewayCommand.RestartWorker);
        });
    }, [
        t,
        question,
        rpc,
        selectedGateway.id,
        selectedGateway.name,
        success,
    ]);

    return (
        <PasswordContainer requiredRole='admin' isFullscreen={true}>
            <SettingsPageContainer
                className='service-edit'
                buttons={[]}
                backUrl={'/settings'}>
                <div className='content-divider'>
                    <div className='content-wrapper'>
                        <div className='database-screen-container'>
                            <div className='button' {...onClickHandler(onShutdownClick)}>
                                <span className='text'>{t('close')}</span>
                            </div>
                            <div className='button' {...onClickHandler(onRestartClick)}>
                                <span
                                    className='text'>{t('reboot')}</span>
                            </div>
                            <div className='button' {...onClickHandler(onSupervisorRestartClick)}>
                                <span
                                    className='text'>{t('supervisor_reboot')}</span>
                            </div>
                            <div className='button' {...onClickHandler(onWorkerRestartClick)}>
                                <span
                                    className='text'>{t('worker_reboot')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    );
}
